import { IMAGES } from 'src/assets'
import clsx from 'clsx'
import { ThumbnailImageProps } from './types'

const ThumbnailImage = ({ src, alt = '', dataTestId, className }: ThumbnailImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      className={clsx('_max-w-full _rounded', className)}
      loading="lazy"
      data-test={dataTestId}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null
        currentTarget.src = IMAGES.NO_IMAGE
      }}
    />
  )
}

export default ThumbnailImage
